import { Box } from "@mui/material";
import { NavigationAndFooterLayout } from "../layouts";
import { NextPageWithLayout, RoleBooklets } from "@cm-websites/common";
import { NextSeo } from "next-seo";
import React from "react";

export const VorbereitungPage: NextPageWithLayout = () => (
  <React.Fragment>
    <NextSeo
      description="Bereite dich entspannt auf dein Krimidinner vor. Laden die Rollenbeschreibungen herunter, um sie deinen Gästen zu schicken."
      title="Vorbereitung | Krimidinner für Zuhause"
    />
    <Box sx={{ pt: { xs: 12, sm: 14, lg: 16 }, pb: { xs: 8, sm: 10, lg: 14, xl: 16 } }}>
      <RoleBooklets />
    </Box>
  </React.Fragment>
);

VorbereitungPage.getLayout = (page) => <NavigationAndFooterLayout>{page}</NavigationAndFooterLayout>;

export default VorbereitungPage;
